<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon class="mr-2">mdi-account-circle</v-icon>
        {{ $t('UserProfileTitle') }}
        <DebugHintIcon :to-json="user" eager title="user"></DebugHintIcon>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        <v-list>
          <v-list-item>
            <template #prepend>
              <v-icon>mdi-account</v-icon>
            </template>
            <v-list-item-title>{{ user?.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('Auth.name') }}</v-list-item-subtitle>
          </v-list-item>

          <v-list-item>
            <template #prepend>
              <v-icon>mdi-email</v-icon>
            </template>
            <v-list-item-title>{{ user?.email }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('Auth.email') }}</v-list-item-subtitle>
          </v-list-item>

          <v-list-item>
            <template #prepend>
              <v-icon>mdi-shield-account</v-icon>
            </template>
            <v-list-item-title>{{ user?.admin ? $t('Admin') : $t('User') }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('Auth.admin') }}</v-list-item-subtitle>
          </v-list-item>

          <v-list-item>
            <template #prepend>
              <v-icon>mdi-identifier</v-icon>
            </template>
            <v-list-item-title>{{ user?.id }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('Auth.id') }}</v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" variant="text" @click="dialog = false">
          {{ $t('ButtonClose') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import useUser from '~/composables/useUser'
import DebugHintIcon from '~/components/Common/DebugHintIcon.vue'

export default defineComponent({
  name: 'UserProfileDialog',
  components: { DebugHintIcon },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup() {
    const { user } = useUser()
    return { user }
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue
      },
      set(value: boolean) {
        this.$emit('update:modelValue', value)
      },
    },
  },
})
</script>
